export enum ButtonsType {
  confirm = 0,
  save = 1,
  warning = 2,
  info = 3,
  upload = 4,
}

export const ButtonsText: any[] = [
  {
    submit: 'Yes',
    cancel: 'No',
  },
  {
    submit: 'Save',
    cancel: 'Cancel',
  },
  {
    cancel: 'Dismiss',
  },
  {
    cancel: 'Dismiss',
  },
  {
    submit: 'Upload',
    cancel: 'Cancel',
  },
];
